'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'flask-round-potion';
var width = 384;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M304 0l-240 0 0 32 32 0 0 121.7C38.6 186.9 0 248.9 0 320 0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-121.7 32 0 0-32-16 0zM128 163.2l0-131.2 128 0 0 141 8.7 4.5C316.6 203.9 352 257.8 352 320l-51.7 0c-26.1 0-51.7-7.1-74.1-20.5l-5-3c-26.7-16-57.3-24.5-88.5-24.5-26.7 0-53 6.2-76.9 18.2L33 301.6c6.2-54.3 39.6-100.3 86.2-124.2l8.7-4.5 0-9.8zM32.9 337.4l6.2-3.1 31.1-15.5c19.4-9.7 40.9-14.8 62.6-14.8 25.4 0 50.2 6.9 72 19.9l5 3c27.4 16.4 58.7 25.1 90.6 25.1l48.5 0C334 425 269.4 480 192 480 109.5 480 41.6 417.6 32.9 337.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;